import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import mis from './assets/mis.jfif'
import strRev from './assets/strRev.jpg'
import lot from './assets/lot.png'
import is from './assets/is.png'
import bble from './assets/bble.png'
import strPrm from './assets/strPrm.png'
import atb from './assets/atb.png'
import csbi from './assets/csbi.webp'
import revLL from './assets/revLL.png'
import mst from './assets/mst.png'
import amh from './assets/amh.jpeg'
import klarge from './assets/klarge.jpg'
import etj from './assets/etj.jfif'
import kse from './assets/kse.png'
const Cisco = () => {
    return (
        <div>
              <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={mis}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Missing number in array</p>
      <NavLink to='/category/Cisco Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  

  
  <div class="card 1">
    <div class="card_image">
      <img src={strRev} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Reverse words in a given string</p>
        <NavLink to='/category/Cisco Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
  
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={strPrm} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Permutations of a given string
</p>
      <NavLink to='/category/Cisco Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={atb} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Array to BST</p>
      <NavLink to='/category/Cisco Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={csbi} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Count set bits</p>
        <NavLink to='/category/Cisco Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={revLL} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Reverse a linked list</p>
      <NavLink to='/category/Cisco Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
   
  
    <div class="card 4">
    <div class="card_image">
      <img src={lot} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Level order traversal</p>
      <NavLink to='/category/Cisco Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={mst} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Minimum Spanning Tree</p>
        <NavLink to='/category/Cisco Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
   
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={amh} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Does array represent Heap</p>
      <NavLink to='/category/Cisco Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={klarge} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Kth largest element in a stream</p>
      <NavLink to='/category/Cisco Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={etj} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Escape the jail</p>
        <NavLink to='/category/Cisco Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={kse} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>K’th smallest element</p>
      <NavLink to='/category/Cisco Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
    <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
    <div class="card 3">
      <div class="card_image"> <img src={is} /> </div>
      <div class="card_title title-white">
        <p style={{fontSize:'1rem'}}>Insertion Sort</p>
        <NavLink to='/category/Cisco Interview question 13'>
      <Button  variant="contained" color="primary" >
            Dive-In
          </Button></NavLink>
      </div>
    </div>
    <div class="card 3">
      <div class="card_image"> <img src={bble} /> </div>
      <div class="card_title title-white">
        <p style={{fontSize:'1rem'}}>Bubble Sort</p>
        <NavLink to='/category/Cisco Interview question 14'>
      <Button  variant="contained" color="primary" >
            Dive-In
          </Button></NavLink>
          </div>
      </div>
   
    </div>
    </div>
       </div>  
    
    )
}

export default Cisco
